export default __webpack_public_path__ + "static/media/copy.a7a5508a.svg";